import React, { useEffect, useState } from 'react';
import { Input } from '../../ui/input';
import { cn } from '../../ui/utils';

const FIBInput = ({ blankId, initialValue, onChange, isDisabled, isError, className, placeholder }) => {
  const [value, setValue] = useState(initialValue || '');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (initialValue !== undefined && !touched) {
      setValue(initialValue);
    }
  }, [initialValue, touched]);

  useEffect(() => {
    if (!touched) return;
    onChange(blankId, value);
  }, [blankId, onChange, touched, value]);

  return (
    <Input
      value={value}
      onChange={(event) => setValue(event.target.value)}
      disabled={isDisabled}
      placeholder={placeholder || 'Answer for blank...'}
      onBlur={() => setTouched(true)}
      aria-invalid={isError || (touched && value === '')}
      className={cn('flex-1', className)}
    />
  );
};

export default FIBInput;
